import { useTranslation } from 'react-i18next'
import { AppleChar } from '../AppleChar'

export function NotInTelegramScreen() {
  const { t } = useTranslation()

  return (
    <div className="fullscreen-state" role="status">
      <AppleChar size={80} mood="confused" />
      <p className="fullscreen-state__title">{t('screens.notInTelegram.title')}</p>
      <p className="fullscreen-state__hint">{t('screens.notInTelegram.hint')}</p>
    </div>
  )
}
